// Centralized CDN base — all integration logos, skill icons, and branded
// images load from the current environment's Supabase Storage. Derived from
// NEXT_PUBLIC_SUPABASE_URL so staging and prod automatically pick the right
// bucket when we migrated to separate projects.
//
// If NEXT_PUBLIC_SUPABASE_URL is absent we fall back to the local Supabase
// URL rather than silently pointing at a remote env — missing env config
// should produce broken images in dev, not hit prod by accident.

const SUPABASE_URL =
  process.env.NEXT_PUBLIC_SUPABASE_URL || "http://localhost:54321";

export const INTEGRATION_LOGOS_CDN = `${SUPABASE_URL}/storage/v1/object/public/integration-logos`;
